import React, { useLayoutEffect } from "react";
import { Switch, useLocation, useHistory } from "react-router-dom";
import ShowPdfDialog from "@icoach/components/dialog/ShowPdfDialog";
import PrivateRoute from "@common/components/route/PrivateRoute";
import IcoachHome from "@icoach/home/";
import { NotFoundPage } from "@error/";
import { CLUB_LOGIN_ROUTER, CLUB_POS_ROUTER, NOTIFICATIONS_ROUTER, CLUB_INVENTORY_ROUTER } from "@icoach/router/routerPath";

const Home = () => {
	const { replace: routeReplace } = useHistory();
	const { pathname: rootPath = "" } = useLocation();

	useLayoutEffect(
		() => {
			const splitPath = rootPath.split("/");
			if (splitPath.length === 2 && splitPath.filter(x => x).length === 0) {
				routeReplace(CLUB_LOGIN_ROUTER.ROOT);
			} else if (splitPath.includes("index") || splitPath.includes("index.html")) {
				routeReplace("/");
			}
		},
		// eslint-disable-next-line
		[rootPath, routeReplace],
	);

	return (
		<React.Fragment>
			<Switch>
				<PrivateRoute static path={CLUB_INVENTORY_ROUTER.BASE} as={IcoachHome} />
				<PrivateRoute static path={CLUB_LOGIN_ROUTER.ROOT} as={IcoachHome} />
				<PrivateRoute static path={NOTIFICATIONS_ROUTER.BASE} as={IcoachHome} />
				<PrivateRoute static path={CLUB_POS_ROUTER.BASE} as={IcoachHome} />
				<PrivateRoute path="*" as={NotFoundPage} />
			</Switch>
			<ShowPdfDialog />
		</React.Fragment>
	);
};

export default Home;
